module.exports = __webpack_public_path__ + "static/media/external-link-icon.5a02adc2.svg";